/**
 * NotFound route — fallback for unmatched paths.
 */
import type { JSX } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundRoute(): JSX.Element {
  return (
    <section className="mx-auto max-w-md py-16 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-nipost-600">404</p>
      <h1 className="mt-2 text-2xl font-bold text-slate-900">Page not found</h1>
      <p className="mt-2 text-sm text-slate-600">
        We couldn&apos;t find the page you&apos;re looking for.
      </p>
      <p className="mt-6">
        <Link
          to="/"
          className="inline-flex items-center rounded-md bg-nipost-600 px-4 py-2 text-sm font-semibold text-white hover:bg-nipost-700"
        >
          Go home
        </Link>
      </p>
    </section>
  );
}
